import CampaignDetailTable from './CampaignDetailTable';

export default CampaignDetailTable;
